import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import Table from "../../../../../core/pagination/Newdatatable";
import NewAssetItemLite from "./AddFilter";
import EditAssetItemLite from "./EditFilter";
import ViewAssetItem from "./ViewFilter";
import AssetitemBarcode from "./AssetitemBarcode";
import StatusUpdate from "./StatusUpdate";
import BulkUpdateOffcanvas from "./BulkStatusUpdate";
import BulkReplaceRetireModal from "./BulkReplaceRetireModal";
import ReplaceRetireDrawer from "./RetireReplace";
import { Select, Spin, Button, Modal, Input } from "antd";
import Swal from "sweetalert2";
import { getPermissionsForMenu } from "../../../Utils/RolePermissions";
import { getApiBaseUrl, LOGIN, ADD_ACTIVITY } from "../../../Config/Config";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import GRAN_LOGO1 from "../../../Logo/Granules_logo1.png"; // Adjust path if needed
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";

const { Option } = Select;

const AssetItems = () => {
  const { state } = useLocation();

  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const menuPath = pathSegments[pathSegments.length - 1];
  const { Write, Delete, Export } = getPermissionsForMenu(menuPath);
  const hasActions = Write || Delete || Export;
  const user = JSON.parse(sessionStorage.getItem("user"));
  const userType = JSON.parse(sessionStorage.getItem("UserType"));
  console.log(userType, "usertyoe");
  const UserId = user?.UserID;

  const [barcodeValue, setBarcodeValue] = useState(null);
  const [blocks, setBlocks] = useState([]);
  const [selectedBlock, setSelectedBlock] = useState(0);
  const [selectedAhu, setSelectedAhu] = useState(0);
  const [selectedArea, setSelectedArea] = useState(0);
  // console.log("Selected selectedArea:", selectedArea);
  const [selectedIds, setSelectedIds] = useState([]);
  const [areas, setAreas] = useState([]);
  const [ahus, setAHUs] = useState([]);

  const [filtersData, setFiltersData] = useState([]);
  const [loadingFilters, setLoadingFilters] = useState(true);
  const roleId = parseInt(sessionStorage.getItem("selectedRole"));
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [viewData, setViewData] = useState(null);
  const [isManualOverride, setIsManualOverride] = useState(false);
  const [isBulkUpdateDrawerVisible, setIsBulkUpdateDrawerVisible] =
    useState(false);
  const [isStatusUpdateDrawerVisible, setIsStatusUpdateDrawerVisible] =
    useState(false);
  const [isReplaceRetireOffcanvasVisible, setIsReplaceRetireOffcanvasVisible] =
    useState(false);

  const [visible, setVisible] = useState(false);
  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [totalRecords, setTotalRecords] = useState(0);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [isNavApplied, setIsNavApplied] = useState(false);
  const [isStatusModalOpen, setIsStatusModalOpen] = useState(false);
  const [isRRSelectMode, setIsRRSelectMode] = useState(false);
  const [rrSelectedRows, setRRSelectedRows] = useState([]);

  // Advanced Search
  const [searchTerm, setSearchTerm] = useState("");
  const searchInputRef = useRef(null);

  // PDF Export
  const [pdfVisible, setPdfVisible] = useState(false);
  const [pdfPassword, setPdfPassword] = useState("");
  const [pdfPasswordError, setPdfPasswordError] = useState("");
  const [pdfAuthLoading, setPdfAuthLoading] = useState(false);
  const [downloadReportLoading, setDownloadReportLoading] = useState(false);

  useEffect(() => {
    if (state?.blockId) {
      setSelectedBlock(Number(state.blockId));
      setSelectedArea(Number(state.areaId || 0));
      setSelectedAhu(Number(state.ahuId || 0));
      setIsNavApplied(true);
    } else {
      setIsNavApplied(true);
    }
  }, [state]);

  const fetchFilters = async (page = 1, limit = 100, search = "") => {
    console.log("entered", !isNavApplied);
    if (!isNavApplied) return;
    try {
      setLoadingFilters(true);
      // const url = `${getApiBaseUrl()}/api/getFiltersListPg?BlockId=${selectedBlock}&Status=0&Barcode=0&pageNumber=${page}&recordslimit=${limit}`;
      const baseParams = `BlockId=${selectedBlock}&Status=0&Rfid=0&AHUId=${selectedAhu}&AreaId=${selectedArea}&ProcessType=${userType}&pageNumber=${page}&recordslimit=${limit}`;
      const searchParam = search.trim()
        ? `&Search=${encodeURIComponent(search.trim())}`
        : "&Search=";
      const url = `${getApiBaseUrl()}/filterph2/getFiltersAdvSearch?${baseParams}${searchParam}`;

      const response = await fetch(url);
      const result = await response.json();
      const list = result?.ResultData || [];
      setFiltersData(list || []);
      if (list?.length > 0) {
        setTotalRecords(list[0]?.TotalCount || 0);
      }
    } catch (err) {
      console.error("Error fetching filters:", err.message);
      setFiltersData([]);
      setTotalRecords(0);
    } finally {
      setLoadingFilters(false);
    }
  };

  useEffect(() => {
    console.log("cvvvvvvvvvvvvvvvvvvvvvvv");

    const handleFilterChange = () => {
      console.log("pppppppppppppppppppppppppppppppppppp");
      fetchFilters();
    };

    window.addEventListener("filtertypechange", handleFilterChange);

    return () => {
      window.removeEventListener("filtertypechange", handleFilterChange);
    };
  }, []);

  useEffect(() => {
    fetchFilters(currentPage, pageSize, searchTerm);
  }, [
    isNavApplied,
    selectedBlock,
    selectedArea,
    selectedAhu,
    currentPage,
    pageSize,
    userType,
    searchTerm,
  ]);

  useEffect(() => {
    const fetchBlocks = async () => {
      try {
        const response = await fetch(`${getApiBaseUrl()}/api/getLocationType`);
        const result = await response.json();
        if (result?.ResultData && result?.ResultData?.length > 0) {
          setBlocks(result.ResultData);
        }
      } catch (err) {
        console.error("Error fetching blocks:", err);
      }
    };
    fetchBlocks();
  }, []);

  useEffect(() => {
    if (selectedBlock === 0) {
      if (!isNavApplied) {
        setAreas([]);
        setSelectedArea(0);
        setAHUs([]);
        setSelectedAhu(0);
      }
      return;
    }

    const fetchAreas = async () => {
      try {
        const response = await fetch(
          `${getApiBaseUrl()}/Areas/getblockareas?BlockId=${selectedBlock}`,
        );
        const result = await response.json();
        setAreas(result?.ResultData || []);
      } catch (error) {
        console.error("Error fetching areas:", error);
      }
    };

    fetchAreas();
  }, [selectedBlock, isNavApplied]);

  useEffect(() => {
    if (selectedBlock === 0 || selectedArea === 0) {
      if (!isNavApplied) {
        setAHUs([]);
        setSelectedAhu(0);
      }
      return;
    }

    const fetchAHU = async () => {
      try {
        const response = await fetch(
          `${getApiBaseUrl()}/ahuph2/getahu?BlockId=${selectedBlock}&AreaId=${selectedArea}`,
        );
        const result = await response.json();
        setAHUs(result?.ResultData || []);
      } catch (error) {
        console.error("Error fetching AHU:", error);
      }
    };

    fetchAHU();
  }, [selectedArea, selectedBlock, isNavApplied]);

  const handleSearch = () => {
    const value = searchInputRef.current?.value?.trim() || "";
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      handleSearch();
    }
  };

  const stageColorMap = {
    "Wash-in": "text-info",
    "Wash-out": "text-info",
    "Dry-in": "text-warning",
    "Dry-out": "text-warning",
    "Storage-in": "text-success",
    "Storage-out": "text-success",
    Installation: "text-primary",
    Replacement: "text-primary",
    Retirement: "text-danger",
    Spare: "text-success",
    New: "text-secondary",
  };

  const handleCheckboxChange = (record, checked) => {
    setSelectedIds((prev) => {
      // ✅ If unchecking → just remove, no validation
      if (!checked) {
        return prev.filter((item) => item.Id !== record.Id);
      }

      // ✅ If checking
      if (prev.length === 0) {
        return [record];
      }

      const currentStatus = prev[0].Status;
      const currentAHU = prev[0].AHUId;

      let messages = [];

      if (record?.Status !== currentStatus) {
        messages.push("All selected filters must have the same status");
      }

      if (currentStatus === 6 && record?.AHUId !== currentAHU) {
        messages.push("All selected filters must have the same AHU");
      }
      if (
        record?.Rfid == null ||
        record?.Rfid == undefined ||
        record?.Rfid == ""
      ) {
        messages.push("Filter does not have RFID, cannot be selected");
      }

      if (messages.length > 0) {
        Swal.fire({
          icon: "error",
          title: "Invalid Selection",
          html: messages.map((m) => `<p>${m}</p>`).join(""),
          confirmButtonText: "OK",
        });
        return prev;
      }

      if (!prev.some((item) => item.Id === record.Id)) {
        return [...prev, record];
      }

      return prev;
    });
  };

  const handleSelectAll = (checked) => {
    if (checked) {
      if (filtersData.length === 0) {
        Swal.fire({
          icon: "warning",
          title: "No Data",
          text: "No filters available to select",
          confirmButtonText: "OK",
        });
        return;
      }

      // Use the status of the first selected record, or the first row if nothing selected
      const referenceStatus =
        selectedIds.length > 0 ? selectedIds[0].Status : filtersData[0].Status;

      // Select all rows matching that status
      const matchingRows = filtersData.filter(
        (item) => item.Status === referenceStatus,
      );

      setSelectedIds(matchingRows);
    } else {
      setSelectedIds([]);
    }
  };

  const handleBlockChange = (blockId) => {
    setSelectedBlock(Number(blockId));
    setSelectedArea(0);
    setSelectedAhu(0);
    setAreas([]);
    setAHUs([]);
    setSelectedIds([]);
    setIsManualOverride(false);
    setIsRRSelectMode(false);
    setRRSelectedRows([]);
  };

  const handleAreaChange = (areaId) => {
    setSelectedArea(Number(areaId) || 0);
    setSelectedAhu(0);
    setAHUs([]);
    setSelectedIds([]);
    setIsManualOverride(false);
    setIsRRSelectMode(false);
    setRRSelectedRows([]);
  };

  const handleAhuChange = (ahuId) => {
    setSelectedAhu(Number(ahuId) || 0);
    setSelectedIds([]);
    setIsManualOverride(false);
    setIsRRSelectMode(false);
    setRRSelectedRows([]);
  };

  const handleBarcodeClick = (record) => {
    setBarcodeValue(record);
  };

  const handleDelete = async (record) => {
    const payload = {
      id: record.Id,
      userId: UserId,
    };

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/deleteFilter`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });

      const result = await response.json();

      if (result?.ResultData && result.ResultData[0]?.Status === "Success") {
        await Swal.fire({
          icon: "success",
          title: "Deleted",
          text: "Filter deleted successfully",
          confirmButtonText: "OK",
        });

        window.location.reload(); // reload only after confirmation
      } else {
        console.error(
          "Delete failed:",
          result?.ResultData?.[0]?.ResultMessage || "Unknown error",
        );

        await Swal.fire({
          icon: "error",
          title: "Failed",
          text:
            result?.ResultData?.[0]?.ResultMessage ||
            "Failed to delete filter.",
        });
      }
    } catch (error) {
      console.error("Error deleting filter:", error);

      await Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while deleting the filter.",
      });
    }
  };

  const handlePasswordSubmit = async () => {
    if (!password) {
      setPasswordError("Please enter your password");
      return;
    }

    setLoading(true);
    setPasswordError("");

    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const loginData = await loginRes.json();

      if (loginData?.Message === "Login successful") {
        loginSuccessful = true;
      } else {
        setPasswordError(
          "Reauthentication failed. Please check your password.",
        );
      }
    } catch (error) {
      console.error(error);
      setPasswordError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
      if (loginSuccessful) {
        setVisible(false);
        setPassword("");
        handleDelete(selectedRecord);
      }
    }
  };

  const baseColumns = [
    {
      title: "Block",
      dataIndex: "locatinname",
      key: "locatinname",
      sorter: (a, b) => a.locatinname.localeCompare(b.locatinname),
    },
    {
      title: "Area",
      dataIndex: "areaname",
      key: "areaname",
      sorter: (a, b) => a.areaname.localeCompare(b.areaname),
    },
    {
      title: "AHU ID",
      dataIndex: "AHUcode",
      key: "AHUcode",
      sorter: (a, b) => a.AHUcode.localeCompare(b.AHUcode),
    },
    {
      title: "Filter ID",
      dataIndex: "Lable",
      key: "Lable",
      sorter: (a, b) => a.Lable.localeCompare(b.Lable),
      render: (text, record) => {
        let dotColor = "bg-secondary";
        const status = record.Status;

        if (status === 1) dotColor = "bg-success";
        else if (status === 2) dotColor = "bg-warning";
        else if (status === 3) dotColor = "bg-info";

        return (
          <Link
            to="#"
            onClick={() => setViewData(record)}
            title={text}
            className="d-flex align-items-center gap-2"
          >
            <span
              className={`rounded-circle ${dotColor}`}
              title={record.StageName || "Unknown"}
              style={{
                width: "10px",
                height: "10px",
                display: "inline-block",
              }}
            ></span>
            {text}
          </Link>
        );
      },
    },
    {
      title: "Filter Type",
      dataIndex: "AssetTypename",
      key: "AssetTypename",
      sorter: (a, b) => a.AssetTypename.localeCompare(b.AssetTypename),
    },
    {
      title: "Last Cleaning",
      dataIndex: "LastCleaningDate",
      key: "LastCleaningDate",
      sorter: (a, b) =>
        new Date(a.LastCleaningDate) - new Date(b.LastCleaningDate),
      render: (text) => {
        if (!text) return "NA";
        const date = new Date(text);
        const pad = (n) => (n < 10 ? "0" + n : n);
        const day = pad(date.getUTCDate());
        const month = pad(date.getUTCMonth() + 1);
        const year = date.getUTCFullYear();
        if (year < 2000) return "NA";
        return `${day}/${month}/${year}`;
      },
    },
    {
      title: "Status",
      dataIndex: "StageName",
      key: "StageName",
      fixed: "right",
      sorter: (a, b) => a.StageName.localeCompare(b.StageName),
      render: (stageName) => {
        const cleanStage = stageName;
        const textColor = stageColorMap[cleanStage] || "text-secondary";
        return <span className={`fw-semibold ${textColor}`}>{cleanStage}</span>;
      },
    },
  ];

  const checkboxColumn = {
    title: (
      <input
        id="select-all-checkbox"
        type="checkbox"
        checked={
          selectedIds.length > 0 &&
          selectedIds.length ===
            filtersData.filter(
              (item) =>
                item.Status ===
                (selectedIds[0]?.Status ?? filtersData[0]?.Status),
            ).length
        }
        onChange={(e) => handleSelectAll(e.target.checked)}
      />
    ),
    dataIndex: "select",
    key: "select",
    width: 50,
    render: (_, record) => (
      <input
        type="checkbox"
        checked={selectedIds.some((item) => item.Id === record.Id)}
        onChange={(e) => handleCheckboxChange(record, e.target.checked)}
      />
    ),
  };

  const rrCheckboxColumn = {
    title: (
      <input
        id="rr-select-all-checkbox"
        type="checkbox"
        checked={
          rrSelectedRows.length > 0 &&
          rrSelectedRows.length === filtersData.length
        }
        onChange={(e) =>
          setRRSelectedRows(e.target.checked ? [...filtersData] : [])
        }
      />
    ),
    dataIndex: "rrSelect",
    key: "rrSelect",
    width: 50,
    render: (_, record) => (
      <input
        type="checkbox"
        checked={rrSelectedRows.some((item) => item.Id === record.Id)}
        onChange={(e) => {
          if (e.target.checked) {
            setRRSelectedRows((prev) => [...prev, record]);
          } else {
            setRRSelectedRows((prev) =>
              prev.filter((item) => item.Id !== record.Id),
            );
          }
        }}
      />
    ),
  };

  useEffect(() => {
    const checkbox = document.getElementById("select-all-checkbox");
    if (checkbox) {
      checkbox.indeterminate =
        selectedIds.length > 0 &&
        selectedIds.length <
          filtersData.filter(
            (item) =>
              item.Status ===
              (selectedIds[0]?.Status ?? filtersData[0]?.Status),
          ).length;
    }
  }, [selectedIds, filtersData]);

  let displayedColumns = baseColumns.filter((col) => {
    if (selectedBlock !== 0 && col.key === "locatinname") return false; // Hide Block
    if (selectedArea !== 0 && col.key === "areaname") return false; // Hide Area
    if (selectedAhu !== 0 && col.key === "AHUcode") return false; // Hide AHU
    return true;
  });

  if (hasActions && selectedIds?.length < 2) {
    displayedColumns.push({
      title: "Action",
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action d-flex align-items-center">
            {Export && (
              <Link
                to="#"
                className="me-2 p-2 d-none"
                onClick={() => handleBarcodeClick(record)}
                data-bs-toggle="offcanvas"
                data-bs-target="#AssetitemBarcode"
                title="View Barcode"
              >
                <i className="fa fa-barcode text-dark"></i>
              </Link>
            )}
            {Write && (
              <Link
                to="#"
                className={`me-2 p-2 `}
                onClick={() => {
                  if (!record?.Rfid || record.Rfid.trim() === "") {
                    Swal.fire({
                      icon: "warning",
                      title: "Cannot Update Status",
                      text: "Filter does not have RFID assigned. Status update is not allowed.",
                      confirmButtonColor: "#3085d6",
                    });
                    return;
                  }
                  setSelectedAsset(record);
                  setIsStatusUpdateDrawerVisible(true);
                }}
                title="Update Status"
              >
                <i className="fa fa-wrench text-success"></i>
              </Link>
            )}
            {Write && (
              <Link
                to="#"
                className="me-2 p-2"
                onClick={() => setSelectedAsset(record)}
                data-bs-toggle="offcanvas"
                data-bs-target="#offcanvasRightEditFilterAsset"
                title="Edit"
              >
                <i data-feather="edit" className="feather-edit text-info"></i>
              </Link>
            )}
            {Write && (
              <Link
                to="#"
                className="me-2 p-2"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedAsset(record);
                  setIsReplaceRetireOffcanvasVisible(true);
                }}
                title="Replace or Retire"
              >
                <i className="fa fa-exchange-alt text-warning"></i>
              </Link>
            )}
            {Write && (
              <div className="d-none">
                <Link
                  to="#"
                  className="me-2 p-2"
                  title="Delete filter"
                  onClick={(e) => {
                    e.preventDefault();
                    setSelectedRecord(record);
                    setVisible(true);
                  }}
                >
                  <i className="feather-trash text-danger"></i>
                </Link>
              </div>
            )}
          </div>
        </div>
      ),
    });
  }

  let finalColumns = displayedColumns;

  if (isRRSelectMode) {
    finalColumns = [rrCheckboxColumn, ...displayedColumns];
  } else if (roleId === 4 && selectedBlock !== 0) {
    finalColumns = [checkboxColumn, ...displayedColumns];
  }

  // PDF Export Configuration
  const reportConfig = useMemo(() => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    const formatDate = (dateString) => {
      if (!dateString) return "NA";
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "NA";
      const year = date.getUTCFullYear();
      if (year < 2000) return "NA";
      const day = String(date.getUTCDate()).padStart(2, "0");
      const month = String(date.getUTCMonth() + 1).padStart(2, "0");
      return `${day}/${month}/${year}`;
    };

    return {
      title: "Filters List",
      filename: `FiltersList_${year}-${month}-${day}_${hours}-${minutes}-${seconds}`,
      columns: [
        { title: "Block", key: "locatinname" },
        { title: "Area", key: "areaname" },
        { title: "AHU ID", key: "AHUcode" },
        { title: "Filter ID", key: "Lable" },
        { title: "Filter Type", key: "AssetTypename" },
        { title: "Last Cleaning", key: "LastCleaningDate", format: formatDate },
        { title: "Status", key: "StageName" },
      ],
    };
  }, []);

  // CHANGED: Now uses getFiltersAdvSearch with current search term and filters
  const fetchFilteredDataForPDF = async () => {
    if (totalRecords === 0) return [];
    try {
      const baseParams = `BlockId=${selectedBlock}&Status=0&Rfid=0&AHUId=${selectedAhu}&AreaId=${selectedArea}&ProcessType=${userType}&pageNumber=1&recordslimit=${totalRecords}`;
      const searchParam = searchTerm.trim()
        ? `&Search=${encodeURIComponent(searchTerm.trim())}`
        : "&Search=";
      const url = `${getApiBaseUrl()}/filterph2/getFiltersAdvSearch?${baseParams}${searchParam}`;

      const response = await fetch(url);
      const result = await response.json();
      return result?.ResultData || [];
    } catch (err) {
      console.error("Error fetching filtered data for PDF:", err);
      return [];
    }
  };

  const handleExportPDF = async () => {
    setDownloadReportLoading(true);
    const fullData = await fetchFilteredDataForPDF();

    const doc = new jsPDF("l", "mm", "a4");
    const pageWidth = doc.internal.pageSize.getWidth();

    const generateHeader = () => {
      doc.addImage(GRAN_LOGO1, "PNG", 10, 10, 20, 20);
      doc.setFontSize(14);
      doc.text("Granules India Limited", 35, 18);
      doc.setFontSize(11);
      doc.text("Gagillapur", 35, 25);
      doc.setFontSize(12);
      doc.text(`Title: ${reportConfig.title}`, 10, 40);
    };

    generateHeader();

    autoTable(doc, {
      startY: 55,
      head: [reportConfig.columns.map((col) => col.title)],
      body: fullData.map((item) =>
        reportConfig.columns.map((col) => {
          if (col.format) return col.format(item[col.key]);
          return item[col.key] || "";
        }),
      ),
      theme: "grid",
      headStyles: { fillColor: [22, 160, 133] },
      margin: { top: 50, bottom: 30 },
      didDrawPage: generateHeader,
    });

    const totalPages = doc.internal.getNumberOfPages();
    for (let i = 1; i <= totalPages; i++) {
      doc.setPage(i);
      doc.setFontSize(10);
      doc.text(
        `Page ${i} of ${totalPages}`,
        pageWidth - 40,
        doc.internal.pageSize.height - 10,
      );

      if (i === totalPages) {
        const footerY = doc.internal.pageSize.height - 20;
        doc.text(`Printed by: ${user?.UserName || "Unknown"}`, 10, footerY);
        const now = new Date();
        doc.text(
          `Printed on: ${String(now.getDate()).padStart(2, "0")}-${String(
            now.getMonth() + 1,
          ).padStart(2, "0")}-${now.getFullYear()} ${String(
            now.getHours(),
          ).padStart(2, "0")}:${String(now.getMinutes()).padStart(
            2,
            "0",
          )}:${String(now.getSeconds()).padStart(2, "0")}`,
          10,
          footerY + 6,
        );
      }
    }

    const pdfBlob = doc.output("blob");
    const formData = new FormData();
    formData.append("file", pdfBlob, `${reportConfig.filename}.pdf`);
    fetch(`${getApiBaseUrl()}/api/uploadReportCopy`, {
      method: "POST",
      body: formData,
    }).catch((err) => console.error("Upload failed:", err));

    doc.save(`${reportConfig.filename}.pdf`);
    setDownloadReportLoading(false);
  };

  const handlePdfPasswordSubmit = async () => {
    if (!pdfPassword) {
      setPdfPasswordError("Please enter your password");
      return;
    }

    setPdfAuthLoading(true);
    setPdfPasswordError("");
    const username = user?.UserName || user?.Username;
    let loginSuccessful = false;

    try {
      const loginRes = await fetch(`${getApiBaseUrl()}${LOGIN}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password: pdfPassword }),
      });

      const loginData = await loginRes.json();
      if (loginData?.Message === "Login successful") {
        loginSuccessful = true;
      } else {
        setPdfPasswordError(
          "Reauthentication failed. Please check your password.",
        );
      }
    } catch (error) {
      setPdfPasswordError("Something went wrong. Please try again.");
    }

    if (loginSuccessful) {
      try {
        const now = new Date();
        const formattedDate = `${now.getFullYear()}-${String(
          now.getMonth() + 1,
        ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
          now.getHours(),
        ).padStart(2, "0")}:${String(now.getMinutes()).padStart(
          2,
          "0",
        )}:${String(now.getSeconds()).padStart(2, "0")}`;

        await fetch(`${getApiBaseUrl()}${ADD_ACTIVITY}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ActivityType: 1,
            PerformedBy: user?.UserID,
            PerformedOn: formattedDate,
            Notes: `${reportConfig.title} downloaded by ${username}`,
            Location: "Reports",
            IsSucces: 1,
          }),
        });
      } catch (err) {
        console.error("Activity log error:", err);
      }

      setPdfVisible(false);
      setPdfPassword("");
      handleExportPDF();
    }

    setPdfAuthLoading(false);
  };

  const renderPdfTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      PDF
    </Tooltip>
  );

  return (
    <>
      {downloadReportLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
          style={{
            zIndex: 1050,
            backdropFilter: "blur(4px)",
          }}
        >
          <Spin
            size="large"
            tip="Generating PDF with current filtered records..."
          />
        </div>
      )}

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/assetmgt/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item" aria-current="page">
                      Filters List
                    </h4>
                  </ol>
                </nav>
                <h6>Manage Filters</h6>
              </div>
            </div>

            <ul className="table-top-head">
              {Export && (
                <li>
                  <OverlayTrigger placement="top" overlay={renderPdfTooltip}>
                    <Link to="#" onClick={() => setPdfVisible(true)}>
                      <ImageWithBasePath
                        src="assets/img/icons/pdf.svg"
                        alt="img"
                      />
                    </Link>
                  </OverlayTrigger>
                </li>
              )}
            </ul>

            {Write && (
              <>
                <div className="page-btn">
                  <Link
                    to="#"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasRightNewFilterAsset"
                    className="btn btn-success btn-sm"
                  >
                    <i className="ti ti-circle-plus fs-4"></i>
                  </Link>
                </div>

                <div className="page-btn">
                  <Link
                    to="#"
                    className="btn btn-primary"
                    title="Bulk Replace/Retire"
                    onClick={() => {
                      if (!isRRSelectMode) {
                        setIsRRSelectMode(true);
                        setRRSelectedRows([]);
                        return;
                      }

                      if (rrSelectedRows.length === 0) {
                        Swal.fire(
                          "No Selection",
                          "Please select at least one filter",
                          "warning",
                        );
                        return;
                      }

                      setIsStatusModalOpen(true);
                    }}
                  >
                    {rrSelectedRows.length > 0
                      ? `Submit (${rrSelectedRows.length})`
                      : "Bulk R/R"}
                  </Link>
                </div>
              </>
            )}
          </div>

          <div className="card table-list-card no-search">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              {/* Advanced Search */}
              <div className="search-set">
                <div className="input-group">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder="Search filters..."
                    ref={searchInputRef}
                    onKeyPress={handleKeyPress}
                    defaultValue={searchTerm}
                  />
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={handleSearch}
                    disabled={loadingFilters}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
              </div>

              <div className="d-flex align-items-center flex-wrap gap-3 my-xl-auto right-content">
                <div style={{ minWidth: "150px" }}>
                  <label className="fw-bold mb-1 d-block">Select Block:</label>
                  <Select
                    style={{ width: "100%" }}
                    value={selectedBlock === 0 ? 0 : selectedBlock}
                    onChange={handleBlockChange}
                    placeholder="Select Block"
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      option?.children
                        ?.toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    <Option key={0} value={0}>
                      All
                    </Option>
                    {blocks.map((block) => (
                      <Option key={block.BlockId} value={block.BlockId}>
                        {block.BlockName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ minWidth: "150px" }}>
                  <label className="fw-bold mb-1 d-block">Select Area:</label>
                  <Select
                    style={{ width: "100%" }}
                    value={selectedArea}
                    onChange={handleAreaChange}
                    placeholder="Select Area"
                    showSearch
                  >
                    <Option value={0}>All</Option>
                    {areas.map((area) => (
                      <Option key={area.Areaid} value={Number(area.Areaid)}>
                        {area.AreaName}
                      </Option>
                    ))}
                  </Select>
                </div>
                <div style={{ minWidth: "250px" }}>
                  <label className="fw-bold mb-1 d-block">Select AHU:</label>
                  <Select
                    style={{ width: "100%" }}
                    value={selectedAhu}
                    onChange={handleAhuChange}
                    placeholder="Select AHU"
                    showSearch
                  >
                    <Option value={0}>All</Option>
                    {ahus.map((ahu) => (
                      <Option key={ahu.ID} value={Number(ahu.ID)}>
                        {ahu.Code}
                      </Option>
                    ))}
                  </Select>
                </div>

                {!isRRSelectMode && selectedIds.length > 1 && (
                  <div style={{ minWidth: "150px" }}>
                    <label className="fw-bold mb-1 d-block">&nbsp;</label>
                    <Button
                      type="primary"
                      size="small"
                      onClick={() => setIsBulkUpdateDrawerVisible(true)}
                    >
                      Bulk Update
                    </Button>
                  </div>
                )}
              </div>
            </div>

            <div className="card-body">
              <div className="table-responsive">
                {loadingFilters ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : filtersData?.length > 0 ? (
                  <Table
                    key={`${selectedBlock}-${selectedArea}-${selectedAhu}-${filtersData.length}-${searchTerm}`}
                    columns={finalColumns}
                    dataSource={filtersData}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    totalRecords={totalRecords}
                    onPageChange={(page, size) => {
                      setCurrentPage(page);
                      setPageSize(size);
                    }}
                  />
                ) : (
                  <p className="text-center my-4">
                    {searchTerm
                      ? "No results found for your search."
                      : "No data available"}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>

        <NewAssetItemLite />
        <StatusUpdate
          selectedAsset={selectedAsset}
          selectedBlock={selectedBlock}
          visible={isStatusUpdateDrawerVisible}
          onClose={() => setIsStatusUpdateDrawerVisible(false)}
        />
        <EditAssetItemLite formData={selectedAsset} />
        <ViewAssetItem formData={viewData} />
        <AssetitemBarcode barcodeValue={barcodeValue} />
        <ReplaceRetireDrawer
          selectedAsset={selectedAsset}
          selectedBlock={selectedBlock}
          visible={isReplaceRetireOffcanvasVisible}
          onClose={() => setIsReplaceRetireOffcanvasVisible(false)}
        />
        <BulkUpdateOffcanvas
          selectedIds={selectedIds}
          setSelectedIds={setSelectedIds}
          fetchFilters={fetchFilters}
          setFiltersData={setFiltersData}
          setLoadingFilters={setLoadingFilters}
          selectedBlock={selectedBlock}
          isManualOverride={isManualOverride}
          setIsManualOverride={setIsManualOverride}
          visible={isBulkUpdateDrawerVisible}
          onClose={() => {
            setIsBulkUpdateDrawerVisible(false);
            setIsManualOverride(false);
          }}
        />
        <BulkReplaceRetireModal
          visible={isStatusModalOpen}
          selectedIds={rrSelectedRows}
          onClose={() => {
            setIsStatusModalOpen(false);
            setIsRRSelectMode(false);
            setRRSelectedRows([]);
          }}
          onSuccess={() => {
            fetchFilters(currentPage, pageSize, searchTerm);
            setIsStatusModalOpen(false);
            setIsRRSelectMode(false);
            setRRSelectedRows([]);
          }}
        />

        {/* Delete Password Modal */}
        <Modal
          title="Confirm Password"
          open={visible}
          onOk={handlePasswordSubmit}
          onCancel={() => setVisible(false)}
          confirmLoading={loading}
          width={350}
        >
          <Spin spinning={loading}>
            <Input.Password
              placeholder="Enter your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
              onCopy={(e) => e.preventDefault()}
              onPaste={(e) => e.preventDefault()}
              onCut={(e) => e.preventDefault()}
            />
            {passwordError && (
              <div className="text-danger mt-2">{passwordError}</div>
            )}
          </Spin>
        </Modal>

        {/* PDF Password Modal */}
        <Modal
          title="Confirm Password"
          open={pdfVisible}
          onCancel={() => {
            setPdfVisible(false);
            setPdfPassword("");
            setPdfPasswordError("");
          }}
          onOk={handlePdfPasswordSubmit}
          confirmLoading={pdfAuthLoading}
          okText="Verify & Download"
          width={400}
        >
          <Input.Password
            placeholder="Enter your password"
            value={pdfPassword}
            onChange={(e) => {
              setPdfPassword(e.target.value);
              setPdfPasswordError("");
            }}
            onPressEnter={handlePdfPasswordSubmit}
          />
          {pdfPasswordError && (
            <div className="text-danger mt-2">{pdfPasswordError}</div>
          )}
        </Modal>
      </div>
    </>
  );
};

export default AssetItems;
